import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  StatesService,
  User,
  UserRolesPermissionsService,
} from '@socium/sociumflow';

export const AUTH_GUARD: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const statesService = inject(StatesService);

  const authUser = statesService.getCurrentUser();

  if (!authUser || !(authUser as User).role) return false;

  return checkUserRolePermissions(route, router);
};

const checkUserRolePermissions = (
  route: ActivatedRouteSnapshot,
  router: Router,
) => {
  const userRolesPermissionsService = inject(UserRolesPermissionsService);

  if (
    route.data?.['roles'] &&
    route.data?.['canPermission'] &&
    !userRolesPermissionsService.hasUserRolesPermissions(
      route.data?.['canPermission'],
      route.data?.['roles'],
    )
  ) {
    router.navigate(['forbidden']);
    return false;
  }
  return true;
};
